import gql from 'graphql-tag';

export const DESTROY_STOCK_DELIVERY_ITEM = gql`
	mutation destroyStockDeliveryItemMutation($id: ID!) {
		destroyStockDeliveryItem(id: $id) 
	}
`;
